import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import App from "./app/App.tsx";
import "./styles/index.css";
import { LateNightProvider } from "./app/context/LateNightContext.tsx";

// Register Firebase Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js",
      );

      console.log("✅ Service Worker Registered:", registration);
    } catch (error) {
      console.error("❌ Service Worker Registration Failed:", error);
    }
  });
}

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <LateNightProvider>
      <App />
    </LateNightProvider>
  </Provider>,
);
